import api from '~api/api'
import { type AIInteractionId, type UserId } from '~types'

export interface AITranscriptPdfOptions {
  userId: UserId
  aiInteractionId: AIInteractionId
  timezone?: string
}

export async function generateAITranscriptPdfBlob(options: AITranscriptPdfOptions): Promise<Blob> {
  const { userId, aiInteractionId, timezone } = options

  const response = await api.post(
    '/ai/print-ai-interaction-transcript/',
    {
      user_id: userId,
      ai_interaction_id: aiInteractionId,
      timezone: timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    { responseType: 'blob' },
  )

  const contentType = response.headers['content-type']
  if (contentType !== 'application/pdf') {
    throw new Error(`Expected PDF but received ${contentType}`)
  }

  return new Blob([response.data], { type: 'application/pdf' })
}
